import React from 'react';

const ImageIcon = ({ size = 32, color = '#90caf9', style = {} }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <rect x="3" y="5" width="18" height="14" rx="2" fill={color} />
    <circle cx="8.5" cy="10.5" r="1.5" fill="#fff" />
    <path d="M21 19L15.5 13.5C14.6716 12.6716 13.3284 12.6716 12.5 13.5L7 19" stroke="#fff" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export default ImageIcon; 